import { fetchDelete, fetchGet, fetchPost, fetchPut } from './fetch';

const API_URL = `/api/v1/organization`;

export interface MonthlyDetailDto {
  monthlySpend: number;
  monthlyLimitAlert: number;
  secondsGenerated: number;
  tracksGenerated: number;
  uniqueUsers: number;
  daysRemaining: number;
}

interface OverviewMonthlyDetailResponse {
  data: MonthlyDetailDto;
}

export const getOverviewMonthlyDetail = async (): Promise<OverviewMonthlyDetailResponse> => {
  const url = `${API_URL}/monthly_detail`;
  return fetchGet<OverviewMonthlyDetailResponse>(url);
};

// id: i.id,
//           "monthlySpend": metadata['monthlySpend'],
//           "secondsGenerated": metadata['secondsGenerated'],
//           "tracksGenerated": metadata['tracksGenerated'],
//           "uniqueUsers": metadata['uniqueUsers']
export interface InvoicesDto {
  id: number;
  monthlySpend: number;
  secondsGenerated: number;
  tracksGenerated: number;
  uniqueUsers: number;
  createdAt: string;
  is_paid: boolean;
}
interface GetInvoicesResponse {
  data: InvoicesDto[];
}

export const getInvoices = async (): Promise<GetInvoicesResponse> => {
  const url = `${API_URL}/invoices`;
  return fetchGet<GetInvoicesResponse>(url);
};

interface CreateOrganizationRequest {
  name: string;
  contact_name: string;
  email: string;
  use_case: string;
  expected_volume: number;
}

export const createOrganization = async (req: CreateOrganizationRequest): Promise<any> => {
  const url = `${API_URL}/apply`;
  return fetchPost<CreateOrganizationRequest, any>(url, req);
};

export interface OrganizationDto {
  name: string;
  contact_name: string;
  email: string;
  expected_volume: number;
  is_verified: boolean;
  monthly_limit_alert: number;
  next_payment_date: string;
  use_case: string;
  has_payment_method: boolean;
}

export const getOrganization = async (): Promise<OrganizationDto> => {
  const url = `${API_URL}/info`;
  return fetchGet<OrganizationDto>(url);
};

interface UpdateOrganizationRequest {
  name?: string;
  contact_name: string;
}

export const updateOrganization = async (req: UpdateOrganizationRequest): Promise<any> => {
  const url = `${API_URL}/edit_profile`;
  return fetchPut<UpdateOrganizationRequest, any>(url, req);
};

interface SetMonthlyLimitAlertRequest {
  monthly_limit_alert: number;
}

export const setMonthlyLimitAlert = async (req: SetMonthlyLimitAlertRequest): Promise<any> => {
  const url = `${API_URL}/set_monthly_limit_alert`;
  return fetchPut<SetMonthlyLimitAlertRequest, any>(url, req);
};

interface DeleteCardRequest {
  id: string;
}

export const DeleteCard = async (req: DeleteCardRequest): Promise<any> => {
  const url = `${API_URL}/card/${req.id}`;
  return fetchDelete<any, any>(url, req);
};

interface ToggleCardRequest {
  id: string;
}

export const ToggleCard = async (req: ToggleCardRequest): Promise<any> => {
  const url = `${API_URL}/card/switch/${req.id}`;
  return fetchPut<any, any>(url, req);
};
